import { Component, Input, Output, EventEmitter } from '@angular/core';
import moment from 'moment';
import { EventsProvider, coEventsParameters } from '../../providers/events/events';
import { ConfigProvider } from '../../providers/config/config';
import { NavController, PopoverController } from 'ionic-angular';
import { CoLocationComponent } from '../co-location/co-location';
import { CoEventDetailsComponent } from '../co-event-details/co-event-details';
import { FilteringProvider } from '../../providers/filtering/filtering';
import { AppState } from '../../config/state';
/**
 * Generated class for the CoEventsExploreComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-events-explore',
  templateUrl: 'co-events-explore.html',
  inputs: ['popOverFilter', 'numberOfEventsToDisplay', 'density', 'clientKeyword']
})
export class CoEventsExploreComponent {

  locationId: string = "";
  eventsFilter: string = `startDate: "${moment().startOf('day').format("YYYY-MM-DD HH:mm:ss")}"`
  featuredEvent: boolean;
  allEvents: Array<coEventsParameters>;
  filteredEvents: Array<coEventsParameters>;
  filteredByPopup: Array<coEventsParameters>;
  hasBeenFilteredByPopup: boolean = false;
  searchTypes: any = null;
  @Input('popOverFilter') popOverFilter: any;
  checkLast: number = 0;
  density3Array: any;
  density3Object: any;
  lastDate: any;
  @Output() onThingsHaveLoaded = new EventEmitter<any>();

  constructor(public eventsProvider: EventsProvider, public config: ConfigProvider, public navCtrl: NavController, public popoverCtrl: PopoverController, public filteringProvider: FilteringProvider, private state : AppState) {
  }

  filterEventsList(typeName, event) {
    this.filterByPopOver({ tracker: 0, 'searchType': typeName });
  }

  goToEventDetails(eventId) {
    this.config.load(this.state.appId).then(cfg => {
      this.navCtrl.push(CoEventDetailsComponent, { eventId: eventId, searchTags: this.searchTypes });
    });
  }

  filterByPopOver(filterObj){
    this.filteringProvider.filterByPopover(filterObj, this.allEvents).then((res)=>{
      this.filteredEvents = res;
    })
  }

  goToLocation(locationId) {
    this.config.load(this.state.appId).then(cfg => {
      this.navCtrl.push(CoLocationComponent, { location: locationId, showNavbar: true });
    });
  }

  getExploreEvents() {
    this.eventsFilter = `startDate: "${moment().startOf('day').format("YYYY-MM-DD HH:mm:ss")}"`;
    this.eventsProvider.getEvents(this.eventsFilter).then((info) => {
      this.allEvents = info.allEvents;
      this.filteredEvents = info.allEvents;
      this.searchTypes = info.searchTypes;
      this.density3Object = {};

      this.density3Object = this.filteredEvents.reduce((red, event) => {
        let currentEventTime = moment(event.eventStart).format("YYYY-DDD HH");
        if (!red[currentEventTime]) red[currentEventTime] = [];
        red[currentEventTime].push(event);
        return red;
      }, {});

      this.density3Array = Object.keys(this.density3Object).map((key) => {
        return this.density3Object[key];
      });
      this.filterByPopOver(this.popOverFilter);
      this.onThingsHaveLoaded.emit();
    });
  };

  //used for getting events on the location details page
  getLocationEvents(locationId: number) {
    this.eventsFilter = `startDate: "${moment().startOf('day').format("YYYY-MM-DD HH:mm:ss")}", locationId:${locationId}`;
    this.eventsProvider.getEvents(this.eventsFilter).then((info) => {
      this.allEvents = info.allEvents;
      this.filteredEvents = info.allEvents;
      this.searchTypes = info.searchTypes;
    });
    this.popOverFilter = {};
  }

  getFilterList() {
    return this.searchTypes;
  };

  getEventColor(eventType) {
    try {
      let eventTypeObject = this.searchTypes.find(object => object.name === eventType);
      return eventTypeObject.color;
    } catch (ex) {
      return "lightblue";
    };
  }

  getEventImage(eventType) {
    try {
      let eventTypeObject = this.searchTypes.find(object => object.name === eventType);
      return eventTypeObject.image;
    } catch (ex) {
      return "";
    }
  }


}


// WEBPACK FOOTER //
// ./src/components/co-events-explore/co-events-explore.ts